import { ControlRow } from '@/pages/AdvancedEditor/components/panels/common/ControlRow';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Divider } from '@mui/material';
import { setDefaultColor } from 'polotno/side-panel/elements-panel';
import { BorderControl, CornerRadiusControl, CurrentValueControl, FillColorControl, OpacityControl } from './controls';

export const DEFAULT_SHAPES_FILL_COLOR = theme.colors.black[300];
setDefaultColor(DEFAULT_SHAPES_FILL_COLOR);

const ShapesDetailsContainer = styled.div`
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.colors.black[200]};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ShapesDetails = () => {
    const { store } = useAdvancedEditorContext();
    const element = store.selectedElements[0];

    if (!checkPolotnoType(element, [polotnoTypes.Figure, polotnoTypes.Line])) {
        return null;
    }

    return (
        <ShapesDetailsContainer data-testid="modify-shape-panel">
            <CurrentValueControl />

            {checkPolotnoType(element, polotnoTypes.Figure) && (
                <>
                    <FillColorControl />

                    <Divider />
                </>
            )}

            <BorderControl />

            <Divider />

            <ControlRow>
                Corner radius
                <CornerRadiusControl />
            </ControlRow>

            <ControlRow>
                Opacity
                <OpacityControl />
            </ControlRow>
        </ShapesDetailsContainer>
    );
};
